import {
  Any,
  Submission,
  Amwins_Orbits_Contracts_Models_FormType,
  DistributionDistributionDetails,
  Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo,
  Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel,
  IdentityBase,
  LogicGridRequestStatus,
  LogicGridRequestClass,
  LogicGridStep,
  LogicGridStepStatus,
  LogicGridRequestEvent,
  LogicGridRequestEventType,
  SalesChannel,
  SubmissionData,
  SubmissionValue_String,
  DataServiceType,
  SubmissionValue_Nullable_DateTime,
  SubmissionValue_Object,
  SubmissionValue_SubmissionRiskData,
  SubmissionRiskData,
  SubmissionValue_Nullable_Boolean,
  SubmissionValue_InsuredV2,
  Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_MailingAddressV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_PersonV1,
  Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimType,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimAmountV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimRepairedV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ElevatedAfterPriorFloodLossV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimSettledV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimSettledDateV1,
  SubmissionValue_Attestation,
  Attestation,
  SubmissionValue_Country,
  SBIXCountry,
  SubmissionValue_Nullable_Int32,
  SubmissionValue_Protections,
  Protections,
  SubmissionValue_Loss,
  Loss,
  SubmissionValue_Nullable_Decimal,
  SubmissionValue_OtherRisksAssociated,
  OtherRisksAssociated,
  SubmissionValue_SubmissionRiskGeolocation,
  SubmissionRiskGeolocation,
  SubmissionValue_Nullable_Double,
  SubmissionValue_DiligentEffortAndRequirements,
  DiligentEffortAndRequirements,
  SubmissionValue_Dictionary_String_Object,
  SubmissionValue_Dictionary_String_RequirementItem,
  SubmissionValue_Mortgagee,
  SeaSysMortgagee,
  SubmissionValue_AdditionalInterestsItem,
  AdditionalInterestsItem,
  SubmissionValue_Agent,
  Agent,
  License,
  SubmissionValue_PaymentV1,
  PaymentV1,
  EpayEpayTokenInfo,
  EpayPaymentStatus,
  SubmissionValue_InsuredEmailOptions,
  SubmissionValue_NFIPCommunityV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_NFIPCommunityV1,
  SubmissionValue_Measurement,
  Amwins_Orbits_Contracts_Models_DataServices_Measurement,
  Amwins_Orbits_Contracts_Models_DataServices_UnitsOfMeasurement,
  SubmissionValue_Underwriter,
  Underwriter,
  SubmissionValue_Agency,
  Agency,
  Quote,
  QuoteStatus,
  DeclineType,
  PriceStatus,
  QuoteValue,
  Amwins_Orbits_Contracts_Models_v2_CoverageModelType,
  Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteBindRequirementsV2,
  Amwins_Orbits_Contracts_Models_Inspections_InspectionType,
  SubmissionDataService,
  HttpLifecyclePersistence,
  HttpRequestStatus,
  HttpRequestErrorModel,
  HttpRequestPersistenceModel,
  HttpResponsePersistenceModel,
  System_Net_HttpStatusCode,
  MunichREPersistence,
  FormState,
  FormTemplateType,
  FormStateStatus,
  GateRules_ResponsesLimitedGateResponse,
  SubmissionV1,
  SubmissionDataV1,
  SubmissionValue_AgentAttestation,
  AgentAttestation,
  SubmissionValue_SubmissionRiskDataV1,
  SubmissionRiskDataV1,
  SubmissionValue_FloodLoss,
  FloodLoss,
  SubmissionValue_MortgageeV1,
  MortgageeV1,
  SubmissionValue_Dictionary_String_String,
  AccountBase,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class SubmissionService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Submission';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static savePreGate(
    params: {
      /**  */
      body?: Submission;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Submission/save/pre-gate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static save(
    params: {
      /**  */
      body?: Submission;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Submission/save';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static savePreGateV1(
    params: {
      /**  */
      body?: SubmissionV1;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Submission/save/v1/pre-gate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static saveV1(
    params: {
      /**  */
      body?: SubmissionV1;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Submission/save/v1';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static selectQuote(
    params: {
      /**  */
      submissionId?: string;
      /**  */
      quoteId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Submission/SelectQuote';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { submissionId: params['submissionId'], quoteId: params['quoteId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static reject(
    params: {
      /**  */
      submissionId: string;
      /**  */
      body?: Any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Submission/{submissionId}/Reject';
      url = url.replace('{submissionId}', params['submissionId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAccountBase(
    params: {
      /**  */
      submissionNumber?: string;
      /**  */
      submissionId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountBase> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Submission/AccountBase';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { submissionNumber: params['submissionNumber'], submissionId: params['submissionId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
